import React from 'react'
import Dashboard from '../Components/Dashboard'
import MainGrid from './Components/MainGrid'

function DietMaster() {
  return (
    <MainGrid />
  )
}

export default DietMaster